import React, { Fragment } from "react";
import Title from 'antd/es/typography/Title';

export default function Blank(props) {
  const {
    blank,
    onChange,
  } = props;

  return (
    <Fragment>
      <Title style={{ width: 'max-content'}} level={4} editable={{ onChange }}>
        {blank}
      </Title>
    </Fragment>
  )
}
